import {
    Component,
    ComponentFactoryResolver,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    QueryList,
    SimpleChange,
    ViewChildren
} from '@angular/core';
import {WidgetDirective} from '@components/widget/widget.directive';
import {DetailLotsComponent} from '@components/widget/detail-lots/detail-lots.component';
import {LoyerMoyenComponent} from '@components/widget/loyer-moyen/loyer-moyen.component';
import {RendementTypologieComponent} from '@components/widget/rendement-typologie/rendement-typologie.component';
import {PopulationComponent} from '@components/widget/population/population.component';
import {PyramideAgesComponent} from '@components/widget/pyramide-ages/pyramide-ages.component';
import {RepartitionComponent} from '@components/widget/repartition/repartition.component';
import {VilleLienComponent} from '@components/widget/ville-lien/ville-lien.component';
import {TensiometreComponent} from '@components/widget/tensiometre/tensiometre.component';
import {Tab} from '@models/tab';
import {MatDialog} from '@angular/material/dialog';
import {CommoditeVilleComponent} from '@components/widget/commodite-ville/commodite-ville.component';
import {TaxeFonciereComponent} from '@components/widget/taxe-fonciere/taxe-fonciere.component';
import {NotesComponent} from '@components/widget/notes/notes.component';
import {PriceEvolComponent} from '@components/widget/price-evol/price-evol.component';
import {DescriptifComponent} from '@components/widget/descriptif/descriptif.component';
import {PhotosComponent} from '@components/widget/photos/photos.component';
import {ContactComponent} from '@components/widget/contact/contact.component';
import {InformationGeneralComponent} from '@components/widget/information-general/information-general.component';
import {SimulateurTravauxComponent} from '@components/widget/simulateur-travaux/simulateur-travaux.component';
import {RevenusComponent} from '@components/widget/revenus/revenus.component';
import {AchatComponent} from '@components/widget/achat/achat.component';
import {ChargesComponent} from '@components/widget/charges/charges.component';
import {FinancementComponent} from '@components/widget/financement/financement.component';
import {ConfigImpotsComponent} from '@components/widget/config-impots/config-impots.component';
import {NgForOfContext} from '@angular/common';
import {PrixMoyenComponent} from '@components/widget/prix-moyen/prix-moyen.component';
import {PrixMoyenGraphComponent} from '@components/widget/prix-moyen-graph/prix-moyen-graph.component';
import {RepartitionInoutComponent} from '@components/widget/repartition-inout/repartition-inout.component';
import {RecapAchatComponent} from '@components/widget/recap-achat/recap-achat.component';
import {RecapLoyerComponent} from '@components/widget/recap-loyer/recap-loyer.component';
import {RecapChargeComponent} from '@components/widget/recap-charge/recap-charge.component';
import {RecapCreditComponent} from '@components/widget/recap-credit/recap-credit.component';
import {RecapKpiComponent} from '@components/widget/recap-kpi/recap-kpi.component';
import {CdkDragDrop, copyArrayItem, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {TabService} from '@services/tab.service';
import {Router} from '@angular/router';
import {Favorite} from '@models/favorite';
import {EMPTY_FAVORITE, EMPTY_USER} from '@models/empty';
import {EvolPrixImmoComponent} from '@components/widget/evol-prix-immo/evol-prix-immo.component';
import {AuthenticationService} from '@services/authentification.service';
import {EtudiantComponent} from '@components/widget/etudiant/etudiant.component';
import {MenagesComponent} from '@components/widget/menages/menages.component';
import {EntreprisesComponent} from '@components/widget/entreprises/entreprises.component';
import {LogementsComponent} from '@components/widget/logements/logements.component';
import {CommercesComponent} from '@components/widget/commerces/commerces.component';
import {ServicesVilleComponent} from '@components/widget/services-ville/services-ville.component';
import {TourismeComponent} from '@components/widget/tourisme/tourisme.component';
import {User} from '@models/user';
import {ConfigRendementToolsComponent} from '@components/widget/config-rendement-tools/config-rendement-tools.component';
import {ConfigCityToolsComponent} from '@components/widget/config-city-tools/config-city-tools.component';
import {SimulatorComponent} from '@components/widget/simulator/simulator.component';
import {ConfigProjectToolsComponent} from '@components/widget/config-project-tools/config-project-tools.component';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ConfigProjectUrlComponent} from '@components/widget/config-project-url/config-project-url.component';
import {ConfigDpeToolsComponent} from '@components/widget/config-dpe-tools/config-dpe-tools.component';
import {ConfigEmpruntToolsComponent} from '@components/widget/config-emprunt-tools/config-emprunt-tools.component';
import {CityMapComponent} from '@components/widget/city-map/city-map.component';
import {LoginFormComponent} from '@components/popup/login-form/login-form.component';
import {TrackingService} from '@services/tracking.service';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';
import {ConfigImpotToolsComponent} from '@components/widget/config-impot-tools/config-impot-tools.component';
import {PopulationActivityComponent} from '@components/widget/population-activity/population-activity.component';
import {VerifDataComponent} from '@components/widget/verif-data/verif-data.component';
import {LocalisationComponent} from '@components/widget/localisation/localisation.component';

@Component({
    selector: 'app-ad-widgets',
    templateUrl: './widgets.component.html',
    styleUrls: ['./widgets.component.scss']
})
export class WidgetsComponent implements OnChanges, OnInit {

    kpi = true;
    w1 = 0;
    w2 = 0;
    w3 = 0;
    // Hack to dectect favorite change because objet with ngOnchange is not working
    cpt = 0;

    module = {
        Annonce: [
            'contact',
            'descriptif',
            'detail-lots',
            'information-general',
            'notes',
            'photo',
            'price-evol',
            'verif-data',
            'localisation',
        ],
        Ville: [
            'loyer-moyen',
            'rendement-typologie',
            'population',
            'pyramide-ages',
            'repartition',
            'repartition-inout',
            'ville-lien',
            'tensiometre',
            'evol-prix-immo',
            'etudiant',
            'menages',
            'entreprises',
            'logements',
            'population-activity',
            'commerces',
            'services-ville',
            'tourisme',
            'city-map',
            'prix-moyen',
            'prix-moyen-graph',
            'taxe-fonciere',
        ],
        Finance: [
            'achat',
            'charges',
            'commodite-ville',
            'financement',
            'revenus',
            'simulateur-travaux',
            'start-project',
            'simulator',
        ],
        Recapitulatif: [
            'recap-achat',
            'recap-charge',
            'recap-credit',
            'recap-kpi',
            'recap-loyer',
        ]
    };

    @ViewChildren(WidgetDirective) widgets: QueryList<WidgetDirective>;

    @Input() favorite: Favorite = Object.assign({}, EMPTY_FAVORITE);
    @Input() tab: Tab;
    @Input() edit: boolean;
    @Input() custom: boolean;
    @Input() link: '';

    @Output() favoriteChange = new EventEmitter();
    user: User = Object.assign({}, EMPTY_USER);
    userTab: Tab;
    mobileTab = [];
    sub = [];
    currentUser = null;
    preview = false;
    returnUrl: string;

    loginForm = null;

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        public dialog: MatDialog,
        public tabService: TabService,
        public router: Router,
        public deviceService: DeviceDetectorService,
        public authenticationService: AuthenticationService,
        public trackingService: TrackingService) {
    }

    ngOnInit() {
        this.router.events.subscribe((val) => {
            if (this.loginForm !== null) {
                clearTimeout(this.loginForm)
                this.loginForm = null;
            }
        });

        if (this.custom === true && this.edit === true) {
            this.preview = true;
        }
        this.returnUrl = this.router.url;
        this.user = this.authenticationService.currentUser;

        let max = Math.max(this.userTab.col1.length, this.userTab.col2.length, this.userTab.col3.length);
        for (let i = 0; i < max; i++) {
            if (this.userTab.col1.length > i) {
                this.mobileTab.push(this.userTab.col1[i]);
            }
            if (this.userTab.col2.length > i) {
                this.mobileTab.push(this.userTab.col2[i]);
            }
            if (this.userTab.col3.length > i) {
                this.mobileTab.push(this.userTab.col3[i]);
            }
        }

        if (!this.authenticationService.isLogin) {
            this.trackingService.click('ad_open_login', '');
            let timeout = 10000;
            // Increase delay for tools
            if (this.custom == false) {
                timeout = 20000;
            }
            this.loginForm = setTimeout(() => {
                const dialogRef = this.dialog.open(LoginFormComponent, {
                    width: '550px',
                    disableClose: true,
                    data: {
                        disableClose: true
                    },
                });
            }, timeout);
        }
    }

    sendChange() {
        this.sub.forEach(s => {
            s.emit();
        });
        this.favoriteChange.emit();
    }

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        if (this.tab !== undefined) {
            if (this.custom === false) {
                this.userTab = this.tab;
                setTimeout(() => {
                    this.buidWidget();
                }, 100);
            } else {
                this.tabService.getTab(this.tab.slug).subscribe(tab => {
                    if (tab === null || !this.authenticationService.isAllowed('expert')) {
                        this.userTab = this.tab;
                    } else {
                        this.userTab = tab;
                    }

                    setTimeout(() => {
                        this.buidWidget();
                    }, 100);
                });
            }
        }
    }

    buidWidget() {
        if (this.widgets === undefined) {
            return;
        }

        const k = this.userTab.template.split('/');
        let ws = '';
        if (k.length > 1) {
            ws = k[1];
        } else {
            ws = k[0];
            this.kpi = false;
        }
        const w = ws.split('-');
        let wlength = 0;
        w.forEach((i) => {
            wlength += parseInt(i, 10);
        });
        wlength = 12 / wlength;

        if (w[0] !== undefined) {
            this.w1 = parseInt(w[0], 10) * wlength;
        }
        if (w[1] !== undefined) {
            this.w2 = parseInt(w[1], 10) * wlength;
        }
        if (w[2] !== undefined) {
            this.w3 = parseInt(w[2], 10) * wlength;
        }

        this.sub = [];
        this.widgets.forEach(function(widget) {
            let componentFactory: any;
            let widgetName = '';

            if (widget.viewContainerRef._hostLView && widget.viewContainerRef._hostLView.context && widget.viewContainerRef._hostLView.context.$implicit) {
                widgetName = widget.viewContainerRef._hostLView.context.$implicit;
            } else if (widget.viewContainerRef._hostLView && widget.viewContainerRef._hostLView) {
                widget.viewContainerRef._hostLView.forEach(elem => {
                    if (elem instanceof NgForOfContext) {
                        widgetName = elem.$implicit;
                    }
                });
            }

            if (widgetName === '' && widget.viewContainerRef.__ngContext__ && widget.viewContainerRef.__ngContext__) {
                widget.viewContainerRef.__ngContext__.forEach(elem => {
                    if (elem instanceof NgForOfContext) {
                        widgetName = elem.$implicit;
                    }
                });
            }

            switch (widgetName) {
                case 'descriptif':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(DescriptifComponent);
                    break;
                case 'photo':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(PhotosComponent);
                    break;
                case 'contact':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(ContactComponent);
                    break;
                case 'detail-lots':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(DetailLotsComponent);
                    break;
                case 'loyer-moyen':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(LoyerMoyenComponent);
                    break;
                case 'rendement-typologie':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(RendementTypologieComponent);
                    break;
                case 'population':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(PopulationComponent);
                    break;
                case 'pyramide-ages':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(PyramideAgesComponent);
                    break;
                case 'repartition':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(RepartitionComponent);
                    break;
                case 'repartition-inout':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(RepartitionInoutComponent);
                    break;
                case 'ville-lien':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(VilleLienComponent);
                    break;
                case 'tensiometre':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(TensiometreComponent);
                    break;
                case 'commodite-ville':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(CommoditeVilleComponent);
                    break;
                case 'taxe-fonciere':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(TaxeFonciereComponent);
                    break;
                case 'city-map':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(CityMapComponent);
                    break;
                case 'notes':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(NotesComponent);
                    break;
                case 'price-evol':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(PriceEvolComponent);
                    break;
                case 'information-general':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(InformationGeneralComponent);
                    break;
                case 'verif-data':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(VerifDataComponent);
                    break;
                case 'localisation':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(LocalisationComponent);
                    break;
                case 'simulateur-travaux':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(SimulateurTravauxComponent);
                    break;
                case 'revenus':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(RevenusComponent);
                    break;
                case 'achat':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(AchatComponent);
                    break;
                case 'charges':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(ChargesComponent);
                    break;
                case 'financement':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(FinancementComponent);
                    break;
                case 'config-impots':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(ConfigImpotsComponent);
                    break;
                case 'prix-moyen':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(PrixMoyenComponent);
                    break;
                case 'prix-moyen-graph':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(PrixMoyenGraphComponent);
                    break;
                case 'recap-achat':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(RecapAchatComponent);
                    break;
                case 'recap-loyer':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(RecapLoyerComponent);
                    break;
                case 'recap-charge':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(RecapChargeComponent);
                    break;
                case 'recap-credit':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(RecapCreditComponent);
                    break;
                case 'recap-kpi':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(RecapKpiComponent);
                    break;
                case 'evol-prix-immo':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(EvolPrixImmoComponent);
                    break;
                case 'config-rendement-tools':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(ConfigRendementToolsComponent);
                    break;
                case 'config-impots-tools':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(ConfigImpotToolsComponent);
                    break;
                case 'config-city-tools':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(ConfigCityToolsComponent);
                    break;
                case 'config-project-tools':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(ConfigProjectToolsComponent);
                    break;
                case 'config-project-url':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(ConfigProjectUrlComponent);
                    break;
                case 'config-dpe-tools':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(ConfigDpeToolsComponent);
                    break;
                case 'config-emprunt-tools':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(ConfigEmpruntToolsComponent);
                    break;
                case 'etudiant':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(EtudiantComponent);
                    break;
                case 'menages':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(MenagesComponent);
                    break;
                case 'entreprises':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(EntreprisesComponent);
                    break;
                case 'logements':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(LogementsComponent);
                    break;
                case 'population-activity':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(PopulationActivityComponent);
                    break;
                case 'commerces':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(CommercesComponent);
                    break;
                case 'services-ville':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(ServicesVilleComponent);
                    break;
                case 'tourisme':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(TourismeComponent);
                    break;
                case 'simulator':
                    componentFactory = this.componentFactoryResolver.resolveComponentFactory(SimulatorComponent);
                    break;
            }
            const viewContainerRef = widget.viewContainerRef;
            viewContainerRef.clear();

            if (componentFactory) {
                const componentRef = viewContainerRef.createComponent(componentFactory);
                (componentRef.instance).favorite = this.favorite;
                (componentRef.instance).preview = this.preview;
                if (componentRef.instance.favoriteChange !== undefined) {
                    componentRef.instance.favoriteChange.subscribe(data => {
                        this.favoriteChange.emit(data);
                        this.cpt++;
                        this.sub.forEach(s => {
                            s.emit();
                        });
                    });
                }

                if (componentRef.instance.extChange !== undefined) {
                    this.sub.push(componentRef.instance.extChange);
                }
            }
        }.bind(this));
    }

    drop(event: CdkDragDrop<string[]>) {
        console.log(event.container.id);
        console.log(event.previousContainer.id);

        if ((event.container.id === 'widget1' || event.container.id === 'widget2' || event.container.id === 'widget3')
            && (event.previousContainer.id === 'widget1' || event.previousContainer.id === 'widget2' || event.previousContainer.id === 'widget3')) {
            // Move beetwwen widget existing in page
            if (event.previousContainer === event.container) {
                moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
            } else {
                transferArrayItem(event.previousContainer.data,
                    event.container.data,
                    event.previousIndex,
                    event.currentIndex);
            }
        } else if (event.container.id !== 'widget1' && event.container.id !== 'widget2' && event.container.id !== 'widget3'
            && event.previousContainer.id !== 'widget1' && event.previousContainer.id !== 'widget2' && event.previousContainer.id !== 'widget3') {
            // Move inside list, nothing to do
        } else if (event.previousContainer.id === 'widget1' || event.previousContainer.id === 'widget2' || event.previousContainer.id === 'widget3') {
            // Remove widget from page
            transferArrayItem(event.previousContainer.data,
                [], // Copy tu null
                event.previousIndex,
                event.currentIndex);

        } else if (event.previousContainer.id !== 'widget1' && event.previousContainer.id !== 'widget2' && event.previousContainer.id !== 'widget3') {
            // Add widget to page
            copyArrayItem(event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex);
        }

        const root = this;
        setTimeout(() => {
            root.buidWidget();
            root.tabService.updateTab(root.tab.slug, root.userTab);
        }, 1);
    }

    changeTemplate(template) {
        this.userTab.template = template;
        this.buidWidget();
    }

    cancelChange() {
        this.userTab = this.tab;
        this.buidWidget();
    }

    save() {
        this.tabService.updateTab(this.tab.slug, this.userTab);
        this.router.navigate([this.link]);
    }

    back() {
        this.router.navigate([this.link]);
    }

    isHidden(item) {
        if (this.w1 !== 0 && this.userTab.col1.indexOf(item) !== -1) {
            return true;
        }
        if (this.w2 !== 0 && this.userTab.col2.indexOf(item) !== -1) {
            return true;
        }
        if (this.w3 !== 0 && this.userTab.col3.indexOf(item) !== -1) {
            return true;
        }

        return false;
    }

    upgradePlan() {
        if (!this.authenticationService.isLogin) {
            const dialogRef = this.dialog.open(LoginFormComponent, {
                width: '550px',
                data: {
                    disableClose: false
                },
            });
        } else {
            const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                width: '520px',
                data: {visuel: 'assets/upgrade/dashboard.png', plan: 'Expert', feature: 'Dashboard personnalisé'}
            });
        }
    }
}
